import React, {useEffect, useState} from 'react';
import Title from 'src/components/AccountSettings/Title';
import Label from 'shared/components/label';
import {Formik} from 'formik';
import AddressVerificationModal from 'src/components/address-verification-modal/address-verification-modal';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import FormikAddressInput from 'src/components/inputs/formik-address-input/formik-address-input';
import ProfileFormFooter from 'src/components/AccountSettings/profile-form/profile-form-footer/profile-form-footer';
import {
  profileFormSchemaCreator,
  ProfileFormSchemaFields,
} from 'src/components/AccountSettings/profile-form/schema';
import {useDispatch} from 'react-redux';
import {errorMessage} from 'shared/actions/notifications';

interface ProfileFormFields {
  _id: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postalCode: string;
  subdivision: string;
  country: string;
}

const profileFormSchemaFields: ProfileFormSchemaFields = [
  'firstName',
  'lastName',
  'addressLine1',
  'addressLine2',
  'city',
  'postalCode',
  'subdivision',
  'country',
];

interface Props {
  initialValues: ProfileFormFields;
  onSubmit: (fields: ProfileFormFields) => void;
  setNavigationAnnouncement: (message: string) => void;
}

const ProfileForm = ({initialValues, onSubmit, setNavigationAnnouncement}: Props) => {
  const [neverScroll, setNeverScroll] = useState(true);
  const dispatch = useDispatch();

  // Trevor use this in the conglomerate
  const scrollToQuestion = (question: string): void => {
    const questionId = document.getElementById(question + '-legend');
    if (questionId && neverScroll) {
      const parentOffset = questionId.parentElement?.offsetTop;
      if (parentOffset !== undefined) {
        setTimeout(() => {
          window.scrollTo(0, parentOffset);
        }, 2);
        setNeverScroll(false);
      }
    }
  };

  useEffect(() => {
    setNavigationAnnouncement('Edit your Profile');
  }, [setNavigationAnnouncement]);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash) {
      scrollToQuestion(hash);
    }
  }, []);

  return (
    <Formik<ProfileFormFields>
      initialValues={initialValues}
      validationSchema={profileFormSchemaCreator(profileFormSchemaFields, {})}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({validateForm}) => (
        <div className="account-settings-form">
          <AddressVerificationModal />
          <Title>Edit Profile</Title>
          <form autoComplete="off">
            <legend className="shared-required-legend"></legend>
            <section className="account-settings-form-section related">
              <div className="form-container">
                <div className="account-settings-form-section-side-by-side">
                  <Label required>
                    First Name
                    <FormikTextInput name="firstName" />
                  </Label>
                  <Label required>
                    Last Name
                    <FormikTextInput name="lastName" />
                  </Label>
                </div>
              </div>
            </section>
            <section className="account-settings-form-section related">
              <div className="form-container address-input">
                <FormikAddressInput />
              </div>
            </section>
          </form>
          <ProfileFormFooter<ProfileFormFields>
            onSubmitClick={async () => {
              const errors = await validateForm();
              if (Object.keys(errors).length > 0) {
                dispatch(errorMessage(`Form errors: ${Object.values(errors).join(', ')}`));
              }
            }}
          />
        </div>
      )}
    </Formik>
  );
};

export default ProfileForm;
